import { baseSchema, Update } from './base'
import { generate } from './generate'
import { z } from 'zod'

export const contentRequestSchema = baseSchema.extend({
  title: z.string(),
  createdAt: z.string(),
  authorId: z.string(),
  baseBranchId: z.string(),
  headBranchId: z.string(),
  description: z.string().nullable(),
  conflictResolutions: z.record(z.enum(['source', 'base'])).nullish(),
  playgroundId: z
    .string()
    .optional()
    .describe('Whether this branch is a playground branch.'),
})

export type ContentRequest = z.infer<typeof contentRequestSchema>
export type ContentRequestUpdate = Update<ContentRequest>

export const contentRequestBaseOps = generate(
  'content-request',
  contentRequestSchema.parse
)
